import { Share2, Link as LinkIcon } from "lucide-react";
import { useState } from "react";
import { SHARE_URL, canNativeShare, nativeShare, telegramShareUrl } from "@/lib/share";

export const ShareSection = () => {
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(SHARE_URL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard unavailable */ }
  };

  const shareBtnClass =
    "h-9 px-4 rounded-lg border flex items-center gap-2 hover:bg-accent/50 active:bg-accent/70 transition-colors text-sm";

  return (
    <div className="py-10 text-center">
      <p className="text-sm font-medium text-foreground mb-3">
        Know someone who'd love this?
      </p>
      <div className="flex justify-center gap-2">
        {canNativeShare() ? (
          <button type="button" onClick={nativeShare} className={shareBtnClass}>
            <Share2 className="w-4 h-4" />
            Share with a friend
          </button>
        ) : (
          <a
            href={telegramShareUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className={shareBtnClass}
          >
            <Share2 className="w-4 h-4" />
            Share with a friend
          </a>
        )}
        <button
          type="button"
          onClick={copyLink}
          className="h-9 px-3 rounded-lg border flex items-center gap-1.5 hover:bg-accent/50 active:bg-accent/70 transition-colors text-sm"
        >
          {copied ? (
            <span className="text-xs font-bold text-primary">✓ Copied</span>
          ) : (
            <>
              <LinkIcon className="w-4 h-4" /> Copy link
            </>
          )}
        </button>
      </div>
    </div>
  );
};
